module.exports = __webpack_public_path__ + "static/media/IMG_0047.3b1fe837.jpg";